module.exports = "/img/s2o_bg_mobile.jpg?35c5bb1910faf583c72bc4fe75f89c31";